import { ILocation } from "../components/menu/Details";
import ILocationAPIObject from "../interfaces/ILocationAPI";
import IVenueSettings from "../interfaces/IVenueSettings";
import IVenue from "../yoello-lib/modules/API/interfaces/IVenue";

/**Basic Helper function for checking if object is empty */
export const isObjectEmpty = (object: any) => {
    if (object === undefined || object === null) {
        return true;
    }
    if (Object.keys(object).length > 0) {
        return false;
    } else {
        return true;
    }
};

/**Checks if the details have been filled in correctly */
// TODO: Make this work from the `required` property.
export function isDetailsFilled(venue: IVenue, venueSettings: IVenueSettings, venueLocation: ILocationAPIObject | ILocation) {
    if (!venueSettings?.owner_email ||
        (typeof venueSettings?.owner_email === "string"
            && venueSettings?.owner_email.length === 0)
    ) {
        console.log("missing owner email", venueSettings.owner_email);
        return false;
    }
    if (!venueSettings?.owner_phone ||
        (typeof venueSettings?.owner_phone === "string"
            && venueSettings?.owner_phone.length === 0)) {
        console.log("missing owner phone", venueSettings.owner_phone);

        return false;
    }
    if (!venueSettings?.time_zone_id) {
        console.log("missing timezone");
        return false;
    }
    if (!venue?.venue_name ||
        (typeof venue?.venue_name === "string"
            && venue?.venue_name.length === 0)) {
        console.log("Venue name", venue.venue_name);

        return false;
    }
    if (!venueSettings?.language_id ||
        (typeof venueSettings?.language_id === "string"
            && venueSettings?.language_id.length === 0)) {
        console.log("missing lang");

        return false;
    }
    if (!venueSettings?.currency_id ||
        (typeof venueSettings?.currency_id === "string"
            && venueSettings?.currency_id.length === 0)) {
        console.log("missig currency");
        return false;
    }
    if (!venueLocation?.location_name ||
        (typeof venueLocation?.location_name === "string"
            && venueLocation?.location_name.length === 0)) {
        console.log("location name");
        return false;
    }
    if (!venueLocation?.address_postcode ||
        (typeof venueLocation?.address_postcode === "string"
            && venueLocation?.address_postcode.length === 0)) {
        console.log("missig currency");

        return false;
    }
    return true;
}
